export default {
      id: "license-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#license",
      toString: function () {
        return this.url;
      }
    }